'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var trackBookmakerRegistrationTap = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(traits) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', (0, _track2.default)(_events.EVENT_BOOKMAKER_REGISTRATION_TAP, (0, _extends3.default)({}, traits), {}, false, true, true));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function trackBookmakerRegistrationTap(_x) {
        return _ref.apply(this, arguments);
    };
}();

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = trackBookmakerRegistrationTap;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackBookmakerRegistrationTap.js
// module id = 2515
// module chunks = 1